export default __webpack_public_path__ + "static/media/DinosaursSeaReptiles_00.d04840fe.png";